import { DOC_FLOW_SENDING_ENTITY } from '../../../../constants/entity'
import { useDocFlowSendingCommunicationTable } from '../../DocFlow.hooks'
import { DocFlowPhaseTable } from '../../DocFlowPhaseTable'
import { DocFlowSendingTableRow } from '../../DocFlowSendingTableRow'
import { updateSendingTableConfig } from '../DocFlowSending.api'

import {
  getSendingCommunicationTableFilterApi,
  getSendingCommunicationTableItemActions,
  getSendingCommunicationTableMassActions,
} from './DocFlowSendingCommunicationTable.utils'

function DocFlowSendingCommunicationTable() {
  const {
    handleToggleSaveToProfile,
    handleToggleSendAdditionalEmail,
    handleToggleSendEmail,
    handleToggleSendEpost,
    selectionData,
    setItemAction,
    setMassAction,
    usersTableData,
  } = useDocFlowSendingCommunicationTable()

  return (
    <DocFlowPhaseTable
      TableRow={DocFlowSendingTableRow}
      emptyStateText='DocumentStapling.SendingTableNoDataKey'
      entity={DOC_FLOW_SENDING_ENTITY}
      getActions={getSendingCommunicationTableItemActions}
      getFilterApi={getSendingCommunicationTableFilterApi}
      getMassActions={getSendingCommunicationTableMassActions}
      selectionData={selectionData}
      setItemAction={setItemAction}
      setMassAction={setMassAction}
      tableLoader={usersTableData}
      tableRowProps={{
        onToggleSaveToProfile: handleToggleSaveToProfile,
        onToggleSendAdditionalEmail: handleToggleSendAdditionalEmail,
        onToggleSendEmail: handleToggleSendEmail,
        onToggleSendEpost: handleToggleSendEpost,
      }}
      updateTableConfig={updateSendingTableConfig}
    />
  )
}

export default DocFlowSendingCommunicationTable
